/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBaselineDensityLarge = createReactComponent("outline", "baseline-density-large", "IconBaselineDensityLarge", [["path", { "d": "M4 4h16", "key": "svg-0" }], ["path", { "d": "M4 20h16", "key": "svg-1" }]]);

export { IconBaselineDensityLarge as default };
//# sourceMappingURL=IconBaselineDensityLarge.mjs.map
